import { createContext } from 'react'

import type { DayObject, DayObjectSearchEntry } from 'types/graphql'

import type { NativeObjectType } from 'src/lib/objects'

export type ObjectContextType = {
  workspaceId: string
  updateProperty: ({
    objectId,
    objectType,
    propertyId,
    propertyValue,
  }: {
    objectId: string
    objectType: NativeObjectType
    propertyId: string
    propertyValue: any
  }) => Promise<void>
  searchEntry: DayObjectSearchEntry | null
  object: DayObject | null
}

const ObjectContext = createContext<ObjectContextType | null>(null)

export default ObjectContext
